import * as yup from 'yup';

export const businessDetailsSchema = yup.object({
  businessName: yup.string().required('Business name is required'),
  businessType: yup.string().required('Business type is required'),
  street: yup.string().required('Business address is required'),
  country: yup.string().required('Country is required'),
  customCountry: yup.string().when('country', {
    is: 'others',
    then: (schema) => schema.required('Please enter your country'),
    otherwise: (schema) => schema.optional(),
  }),
  state: yup.string().required('State is required'),
  customState: yup.string().when('state', {
    is: 'others',
    then: (schema) => schema.required('Please enter your state'),
    otherwise: (schema) => schema.optional(),
  }),
  lga: yup.string().required('LGA/City is required'),
  customLga: yup.string().when('lga', {
    is: 'others',
    then: (schema) => schema.required('Please enter your LGA/City'),
    otherwise: (schema) => schema.optional(),
  }),
  officeAddress: yup.string().optional(),
  rcNumber: yup.string().when('businessType', {
    is: 'registered',
    then: (schema) =>
      schema.required('Business registration number is required'),
    otherwise: (schema) => schema.optional(),
  }),
  businessIndustry: yup.string().required('Business industry is required'),
  customIndustry: yup.string().when('businessIndustry', {
    is: 'others',
    then: (schema) => schema.required('Please specify your industry'),
    otherwise: (schema) => schema.optional(),
  }),
  businessRegistrationCertificate: yup.mixed<File>().nullable().optional(),
  businessDescription: yup
    .string()
    .required('Business description is required')
    .min(20, 'Description must be at least 20 characters'),
});

export const personalDetailsSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  middleName: yup.string().optional(),
  dateOfBirth: yup.string().required('Date of birth is required'),
  emailAddress: yup
    .string()
    .email('Invalid email address')
    .required('Email address is required'),
  phoneNumber: yup.string().required('Phone number is required'),
  nationality: yup.string().required('Nationality is required'),
  nin: yup.string().optional(),
});

export const residentialAddressSchema = yup.object({
  street: yup.string().required('Street address is required'),
  city: yup.string().required('City is required'),
  stateProvince: yup.string().required('State/Province is required'),
  postalCode: yup.string().required('Postal code is required'),
  country: yup.string().required('Country is required'),
  proofOfAddress: yup.mixed<File>().nullable().optional(),
});

export const validIDSchema = yup.object({
  idType: yup.string().required('ID type is required'),
  idNumber: yup.string().required('ID number is required'),
  dateOfIssue: yup.string().required('Date of issue is required'),
  expiringDate: yup.string().required('Expiring date is required'),
  idDocument: yup.mixed<File>().nullable().optional(),
});

export type BusinessDetailsFormData = yup.InferType<
  typeof businessDetailsSchema
>;

export type PersonalDetailsFormData = yup.InferType<
  typeof personalDetailsSchema
>;

export type ResidentialAddressFormData = yup.InferType<
  typeof residentialAddressSchema
>;

export type ValidIDFormData = yup.InferType<typeof validIDSchema>;
